export const partnerList = [
    {
        // id: 17, // For now GV partner id is 75, search sdkluvguw to change to 17 all related
        id: 75,
        name: 'GV'
    },
    {
        id: 24,
        name: 'CNE'
    },
    {
        id: 0,
        name: 'OTHERS'
    }
]

export const driverDocUploadListCA = [
    {
        type: 'driver_license',
        position: 1,
        id: 'DL-0',
        name: 'license_front',
        signature: undefined
    },
    {
        type: 'driver_license',
        position: 0,
        id: 'DL-1',
        name: 'license_back',
        signature: undefined
    },
    {
        type: 'vehicle_insurance',
        position: 1,
        id: 'AI-0',
        name: 'auto_insurance_front',
        signature: undefined
    },
    {
        type: 'vehicle_insurance',
        position: 0,
        id: 'AI-1',
        name: 'auto_insurance_back',
        signature: undefined
    },
    {
        type: 'training_certificate',
        position: 1,
        id: 'TC',
        name: 'training_certificate',
        signature: undefined
    }
]

export const driverDocUploadListUS = [
    {
        type: 'driver_license',
        position: 1,
        id: 'DL-0',
        name: 'license_front',
        signature: undefined
    },
    {
        type: 'driver_license',
        position: 0,
        id: 'DL-1',
        name: 'license_back',
        signature: undefined
    },
    {
        type: 'vehicle_insurance',
        position: 1,
        id: 'AI-0',
        name: 'auto_insurance_front',
        signature: undefined
    },
    {
        type: 'vehicle_insurance',
        position: 0,
        id: 'AI-1',
        name: 'auto_insurance_back',
        signature: undefined
    },
    {
        type: 'training_certificate',
        position: 1,
        id: 'TC',
        name: 'training_certificate',
        signature: undefined
    },
    {
        type: 'placeholder',
        position: 1,
        id: 'placeholder',
        name: 'placeholder',
        signature: undefined
    },
    {
        type: 'W9',
        position: 1,
        id: 'W9-1',
        name: 'W9_1',
        signature: undefined
    },
    {
        type: 'W9',
        position: 0,
        id: 'W9-2',
        name: 'W9_2',
        signature: undefined
    },
    {
        type: 'W9',
        position: 1,
        id: 'W9-3',
        name: 'W9_3',
        signature: undefined
    },
    {
        type: 'W9',
        position: 0,
        id: 'W9-4',
        name: 'W9_4',
        signature: undefined
    },
    {
        type: 'W9',
        position: 1,
        id: 'W9-5',
        name: 'W9_5',
        signature: undefined
    },
    {
        type: 'W9',
        position: 0,
        id: 'W9',
        name: 'W9_6',
        signature: undefined
    },
    {
        type: 'worker_compensation',
        position: 1,
        id: 'WC-1',
        name: 'WC_1',
        signature: undefined
    },
    {
        type: 'worker_compensation',
        position: 0,
        id: 'WC-2',
        name: 'WC_2',
        signature: undefined
    }
]

export const MarkerTypes = {
    DRIVER: "driver",
    WAREHOUSE: "warehouse",
    APARTMENT: "apartment",
    NORMAL: "normal",
    OTHER: "other"
}

export const MarkerIconPath = {
    DRIVER: "./images/markers/car.png",
    WAREHOUSE: "./images/markers/warehouse.png",
    DEFAULT: "./images/markers/default.png",
}

export const ErrorTypes = {
    JSON: 0,
    HTML: 1
}

export const MapModes = {
    NONE: "none",
    SELECT_START: "select_start",
    SELECT_END: "select_end",
    SELECT_MARKER: "select_marker",
    ASSIGN_ROUTE: "assign_route"
}